import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaGithub, FaLinkedin } from "react-icons/fa";

const Contact = () => {
  return (
    <div id="contact" className="border-b border-neutral-300 pb-20 text-center">
      {/* Heading */}
      <h1 className="my-10 text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#703D99] to-[#5A2E7E]">
        Let's Connect
      </h1>

      {/* Contact Details */}
      <div className="text-lg tracking-tighter text-gray-800 space-y-4">
        <p className="flex items-center justify-center gap-2">
          <FaMapMarkerAlt className="text-[#703D99]" /> Hyderabad, India
        </p>
        <p className="flex items-center justify-center gap-2">
          <FaPhoneAlt className="text-[#703D99]" />
          <a href="tel:+918897878118" className="hover:underline hover:text-[#5A2E7E] transition">
            +91 889 787 8118
          </a>
        </p>
        <p className="flex items-center justify-center gap-2">
          <FaEnvelope className="text-[#703D99]" />
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=abhiramgargeya08@gmail.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:underline hover:text-[#5A2E7E] transition">
            abhiramgargeya08@gmail.com
          </a>

        </p>
      </div>

      
    </div>
  );
};

export default Contact;
